/// <reference path="../../../components/models/meevo.model.custom.ts" />
/// <reference path="../../../components/controls/spinner.ts" />

module Meevo.Plugins.InventoryCount {
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
    import MeevoSpinnerChangeType = Meevo.Components.Controls.MeevoSpinnerChangeType;
    export class BarcodeImportReconcilerModalController {
        public loaded: boolean = false;
        public context: any = {};
        public sortedBy: string = 'variantDisplayName';

        // WI 130400: live (a getter, not a $onInit snapshot) so the primary button
        // reads "Next" only while at least one lot-tracked variant still has a
        // non-zero count. If the user zeros all lot-tracked spinners, no lot modal
        // opens (the callback filters by importCount > 0), so the button should read
        // "Apply" — importCount is kept current by the spinner change handlers.
        public get hasLotTracked(): boolean {
            if (!this.options || !this.options.variants) return false;
            // Sum the retail + shop spinner values (coalescing undefined to 0) rather
            // than reading item.importCount: for a single-type variant the unused side
            // stays undefined, and onRetailCountChanged/onShopCountChanged compute
            // importCount = retailImportCount + shopImportCount → NaN mid-edit (it's
            // only reconciled by importScans() on click). Reading importCount here
            // would coerce that NaN to 0 and wrongly flip "Next" to "Apply".
            return this.options.variants.some(v =>
                !!v.trackLots && ((v.retailImportCount || 0) + (v.shopImportCount || 0)) > 0);
        }

        static $inject = [
            "meevo.components.modal.ModalService",
            "options"
        ];

        constructor(
            protected modalService: Meevo.Components.Modal.IModalService,
            public options : any
        ) { 
            if (options.product && options.product.displayName) {
                options.product.displayName = options.product.displayName.replace(/\|/g, ' ');
            }
        }

        $onInit() {
            this.loaded = true;
            this.options.variants.forEach((item) => {
                if (this.showShopSpinner(item) && !this.showRetailSpinner(item)) {
                    item.shopImportCount = item.importCount 
                } else {
                    item.retailImportCount = item.importCount;
                }    
                item.isCounted = true;
                item.variantDisplayName = item.displayName ? `${item.productName} - ${item.displayName.replace('|',' ')}` : item.productName;
                item.scanOrder = this.options.uniqueCodes.indexOf(item.barCode) + 1;

            });
            this.context.closeContext = () => this.closeModal();
        }

        closeModal() {
            this.modalService.hide();
        }

        importScans() {
            this.options.variants.forEach(item => {
                if (item.productInventoryType == ProductInventoryTypeEnum.Retail) {
                    item.importCount = item.retailImportCount;
                } else if (item.productInventoryType == ProductInventoryTypeEnum.ShopSupply) {
                    item.importCount = item.shopImportCount;
                }
            });
            
            this.modalService.hideWithResponse(this.options.variants);
        }

        switchSortOrder(type: string) : void {
            this.sortedBy = type;
        }

        currentInventoryTypeChange(val) {
            this.modalService.hideWithResponse(val);
        }

        showRetailSpinner(item) {
            return [Meevo.Model.ProductInventoryTypeEnum.Retail, Meevo.Model.ProductInventoryTypeEnum.RetailOrShopSupply].some(x => x == item.productInventoryType);
        }
       
        showShopSpinner(item) {
            return [Meevo.Model.ProductInventoryTypeEnum.ShopSupply, Meevo.Model.ProductInventoryTypeEnum.RetailOrShopSupply].some(x => x == item.productInventoryType);
        }

        getRetailSpinnerMax(item) {
            return !this.showShopSpinner(item) ? 99999 : item.importCount
        }

        getShopSpinnerMax(item) {
            return !this.showRetailSpinner(item) ? 99999 : item.importCount
        }
        
        onRetailCountChanged(item, type: MeevoSpinnerChangeType) {
            if (type == MeevoSpinnerChangeType.Arrows && this.showShopSpinner(item) && item.retailImportCount <= item.importCount) {
                item.shopImportCount = item.importCount - item.retailImportCount
            }
            item.importCount = item.retailImportCount + item.shopImportCount;
        }

        onShopCountChanged(item, type: MeevoSpinnerChangeType) {
            if (type == MeevoSpinnerChangeType.Arrows && this.showRetailSpinner(item) && item.shopImportCount <= item.importCount) {
                item.retailImportCount = item.importCount - item.shopImportCount
            }
            item.importCount = item.retailImportCount + item.shopImportCount;
        }

    }

    angular.module("meevo.plugins.inventoryCount")
        .controller("meevo.plugins.inventoryCount.BarcodeImportReconcilerModalController", BarcodeImportReconcilerModalController);
}

